import { render, staticRenderFns } from "./LicenseCard.vue?vue&type=template&id=2d422678&"
import script from "./LicenseCard.vue?vue&type=script&lang=js&"
export * from "./LicenseCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports